module.exports = __webpack_public_path__ + "img/pattern.d2f36518.png";